import { FeatureFlagsContext } from "@/modules/common/context/feature-flags.provider";
import { useContext } from "react";

const useFeatureFlags = () => useContext(FeatureFlagsContext);


export default useFeatureFlags;
